export default "__VITE_ASSET__DMK9jqHO__"